import React, { useEffect, useState, useImperativeHandle } from "react";
import { createTheme, makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { runtime } from "@codeArt/common";
import Button from "@codeArt/components/button/index";
import { HelpLink } from "@codeArt/components/button/link";
/* import _SweetAlert from 'react-bootstrap-sweetalert'; */
import { SwipeableDrawer, Snackbar as _Snackbar } from "@material-ui/core";
import { Scrollbar } from "@codeArt/components/Scrollbar";
import { type } from "@codeArt/utils/common";
import Swal from 'sweetalert2';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const drawerTheme = createTheme({
  breakpoints: {
    values: {
      xs: 507.95,
      sm: 663.95,
      md: 1023.95,
      lg: 1343.95,
      xl: 1983.95
    }
  }
});

const getPaperStyle = size => {
  let paperStyle = null;
  switch (size) {
    case "auto":
      paperStyle = {};
      break;
    case "xs":
      paperStyle = {
        width: "444px",
        [drawerTheme.breakpoints.down("xs")]: {
          width: "100%"
        }
      };
      break;
    case "sm":
      paperStyle = {
        width: "600px",
        [drawerTheme.breakpoints.down("sm")]: {
          width: "100%"
        }
      };
      break;
    case "md":
      paperStyle = {
        width: "960px",
        [drawerTheme.breakpoints.down("md")]: {
          width: "100%"
        }
      };
      break;
    case "lg":
      paperStyle = {
        width: "1280px !important",
        [drawerTheme.breakpoints.down("lg")]: {
          width: "100% !important"
        }
      };
      break;
    case "xl":
      paperStyle = {
        width: "1920px",
        [drawerTheme.breakpoints.down("xl")]: {
          width: "100%;"
        }
      };
      break;
    case "full":
      paperStyle = {
        width: "100%"
      };
      break;
    case "col-8":
      paperStyle = {
        width: "66.66% !important"
      };
      break;
    case "col-4":
      paperStyle = {
        width: "33.33% !important"
      };
      break;
    case "s80":
      paperStyle = {
        width: "80%"
      };
      break;
    default:
  }
  return paperStyle;
};

const useStyles = makeStyles(theme => ({
  root: {},
  drawer: ({ size, backdrop }) => {
    let paperStyle = getPaperStyle(size);
    let backdropStyle = {};

    if (backdrop === false) backdropStyle = { left: "auto !important" };

    return {
      "& .MuiDrawer-paper": paperStyle,
      ...backdropStyle
    };
  },
  noDrag: () => ({
    "-webkit-app-region": "no-drag",
    // "-webkit-user-select":"none" 文字可以有光标覆盖效果
  })
}));

const Modal = React.forwardRef(
  (
    {
      title,
      showClose,
      tools,
      header,
      titleClassName,
      help,
      drawer,
      size,
      children,
      containerFull,
      containerSpace,
      containerClassName,
      height,
      full,
      backdrop,
      disableEnforceFocus,
      paperProps,
      keepMounted,
      onEntered,
      onExit,
      opened,
      disableBackdropClick
    },
    ref
  ) => {
    const [isOpen, setIsOpen] = useState(opened||false);
    const [config, setConfig] = useState({});

    const classes = useStyles({ size, backdrop });

    const open = p => {
      setConfig(p || {});
      setIsOpen(true);
    };

    useImperativeHandle(ref, () => ({ open, close }));

    const close = p => {
      let obj = Object.assign(config, p);
      setConfig(obj);
      setIsOpen(false);
      if (keepMounted) handleEvent("onExit"); //如果是keepMounted状态，那么实际上窗口没被销毁，就不能触发onExit事件，所以此处主动触发下
    };

    const handleEvent = e => {
      let p = { onEntered, onExit, ...config };
      if (p[e]) p[e]();
    };

    const renderTools = () => {
      if (tools) return tools;
      return showClose !== false ? (
        <IconButton
          onClick={() => {
            close();
          }}
          aria-label="Close"
        >
          <CloseIcon />
        </IconButton>
      ) : null;
    };

    const renderTitle = () => {
      return title || header ? (
        <AppBar className="position-relative no-shadow e-app" color="inherit">
          <Toolbar
            disableGutters={true}
            className={`c-lb no-shadow px-3 px-sm-0 mx-0 mx-sm-3 mx-md-4 ${titleClassName}`}
          >
            {header ? (
              header
            ) : (
              <React.Fragment>
                <div className="d-flex flex-row c-flex-1 justify-content-start align-items-center">
                  <p className={`mb-0 text-dark c-text-s3 c-ellipsis-1 ${classes.noDrag}`}>
                    {title}
                  </p>
                  {help ? (
                    <HelpLink className="ml-2" size="md" href={help} />
                  ) : null}
                </div>
                {renderTools()}
              </React.Fragment>
            )}
          </Toolbar>
        </AppBar>
      ) : null;
    };

    const renderBody = () => {
      if (size === "auto") {
        return children;
      }

      let containerMargin = drawer === "right" || drawer === "left" || drawer === false ? `mx-3 ${containerSpace ? "mx-md-4" : ""}` : "mx-0";

      if (drawer === "right" || drawer === "left") {
        return (
          <Scrollbar className="scrollbar">
            <div
              className={`${containerMargin} ${containerClassName} ${containerFull ? "h-100" : ""}`}
            >
              {children}
            </div>
          </Scrollbar>
        );
      } else {
        if (height) {
          return (
            <Scrollbar className="scrollbar" style={{ height }}>
              <div className={`${containerMargin}  ${containerClassName}`}>{children}</div>
            </Scrollbar>
          );
        } else {
          //自适应大小
          return (
            <div className={`${containerMargin}  ${containerClassName}`}>{children}</div>
          );
        }
      }
    };

    const renderFull = () => {
      return (
        <Dialog
          fullScreen
          open={isOpen}
          TransitionComponent={Transition}
          TransitionProps={{
            onEntered: () => handleEvent("onEntered"),
            onExit: () => handleEvent("onExit")
          }}
        // onEntered={() => handleEvent("onEntered")}
        // onExit={() => handleEvent("onExit")}
        >
          {renderTitle()}
          {renderBody()}
        </Dialog>
      );
    };

    const renderSize = () => {
      return (
        <Dialog
          fullWidth={true}
          maxWidth={size}
          open={isOpen}
          TransitionProps={{
            onEntered: () => handleEvent("onEntered"),
            onExit: () => handleEvent("onExit")
          }}
        >
          {renderTitle()}
          {renderBody()}
        </Dialog>
      );
    };

    const renderDrawer = () => {
      const iOS =
        process.browser && /iPad|iPhone|iPod/.test(navigator.userAgent);

      let modalProps = { keepMounted };
      if (backdrop === false) modalProps.hideBackdrop = true;
      
      return (
        <SwipeableDrawer
          className={classes.drawer}
          disableBackdropTransition={!iOS}
          disableDiscovery={iOS}
          swipeAreaWidth={0} //必须为0，不然可以触摸弹出窗口，体验很不好
          ModalProps={{ ...modalProps }}
          PaperProps={{ ...paperProps }}
          anchor={drawer}
          disableEnforceFocus={disableEnforceFocus}
          onOpen={() => {
            setIsOpen(true);
          }}
          open={isOpen}
          onClose={(e,reason) => {
            if(disableBackdropClick && reason==="backdropClick") return false;
            setIsOpen(false);
          }}
        >
          {renderTitle()}
          {renderBody()}
          <Temp
            onEntered={() => handleEvent("onEntered")}
            onExit={() => handleEvent("onExit")}
          />
        </SwipeableDrawer>
      );
    };

    const Isfull = () => {
      return full || size === "full";
    };

    if (drawer) return renderDrawer();
    if (Isfull()) return renderFull();
    return renderSize();
  }
);

export default Modal;

Modal.defaultProps = {
  size: "lg",
  drawer: "right",
  full: false,
  containerSpace: true,
  containerClassName: "",
  titleClassName: "",
  disableEnforceFocus: true //默认值原本是false,为false的时候，窗口外部的元素是无法获得输入焦点的，如果窗口内部有文本编辑器，那么文本编辑器有弹窗（比如插入链接）的时候，就无法输入了，所以这里默认值为true,表示窗体不再屏蔽外部焦点
};

Modal.pageProps = {
  //将modal模拟成一个page的效果
  containerFull: true,
  titleClassName: "c-px-3 c-mx-0",
  containerClassName: "c-bg-body c-px-0 c-mx-0",
  size: "full"
};

const Temp = ({ onEntered, onExit }) => {
  useEffect(() => {
    if (onEntered) onEntered();

    return () => {
      if (onExit) onExit();
    };
  }, []);

  return null;
};

//专门用于从底部或者顶部弹出的modal
export class Sheet extends React.Component {
  open(p) {
    this.refs.modal.open(p);
  }

  close(p) {
    this.refs.modal.close(p);
  }

  render() {
    var p = { ...this.props };
    delete p.ref;
    delete p.size;
    return (
      //当有header，我们不希望容器和header一起滚动，仅容器内部滚动
      <Modal
        ref="modal"
        size="full"
        drawer="bottom"
        containerClassName={p.header ? "c-scroll" : ""}
        paperProps={{ className: "c-mxh80" }}
        {...p}
      />
    );
  }
}

// Sheet.propTypes = {
//   height: PropTypes.string.isRequired
// };

Sheet.defaultProps = {
  drawer: "bottom"
};

export class Confirm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
    Confirm.current = this;
  }

  open(title, content, onOk, onCancel) {
    this.setState({
      title,
      content,
      onOk,
      onCancel,
      open: true
    });
  }

  cancel() {
    let { onCancel } = this.state;
    if (onCancel) onCancel();
    this.setState({ open: false });
  }

  ok() {
    let { onOk } = this.state;
    if (onOk) onOk();
    this.setState({ open: false });
  }

  render() {
    let { title, content } = this.state;
    return (
      <Dialog maxWidth={"lg"} open={this.state.open}>
        <p
          className="c-text-s4 m-3 c-text-sm-s5 m-sm-4 c-mb-2"
          style={{ minWidth: runtime.pc ? 500 : 200 }}
        >
          {title}
        </p>
        {content ? (
          <DialogContent>
            <DialogContentText>{content}</DialogContentText>
          </DialogContent>
        ) : null}
        <DialogActions className="c-confirm-actions">
          <Button
            className="c-w-vsm-100"
            onClick={() => this.ok()}
            color="primary"
          >
            确定
          </Button>
          <Button
            className="c-w-vsm-100"
            onClick={() => this.cancel()}
            color="secondary"
            autoFocus
          >
            取消
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

/* export class Alert extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    }
    Alert.current = this;
  }

  open(title, content, onOk) {
    this.setState({
      title, content, onOk, open: true
    });
  }

  ok() {
    let { onOk } = this.state;
    if (onOk) onOk();
    this.setState({ open: false });
  }

  render() {
    let { title, content } = this.state;
    return (
      <Dialog
        maxWidth={"lg"}
        open={this.state.open}
      >
        <p className="c-text-s4 m-3 c-text-sm-s5 m-sm-4 c-mb-2" style={{ minWidth: runtime.pc ? 500 : 200 }}>{title}</p>
        {
          content ?
            <DialogContent>
              <DialogContentText>
                {content}
              </DialogContentText>
            </DialogContent> : null
        }
        <DialogActions className="c-alert-actions">
          <Button className="c-w-vsm-100" onClick={() => this.ok()} color="primary">
            确定
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
} */

/* export class SweetConfirm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    }
    SweetConfirm.current = this;
  }

  open({ title, content, onOk, onCancel, okText, cancelText, type }) {
    this.setState({
      title, content, onOk, onCancel, open: true, okText, cancelText, type
    });
  }

  cancel() {
    let { onCancel } = this.state;
    if (onCancel) onCancel();
    this.setState({ open: false });
  }

  ok() {
    let { onOk } = this.state;
    if (onOk) onOk();
    this.setState({ open: false });
  }


  title() {
    let { title } = this.state;
    if (!title) return '';
    return <p className="mb-0 c-text-s3">{title}</p>
  }

  render() {
    let { title, content, open, okText, cancelText, type } = this.state;
    let p = {};
    if (type) p[type] = true; else p.warning = true;
    return (
      <_SweetAlert show={open}
        {...p}
        showCancel
        confirmBtnText={okText || "确定"}
        confirmBtnBsStyle="danger"
        cancelBtnBsStyle="default"
        cancelBtnText={cancelText || "取消"}
        title={this.title()}
        closeOnClickOutside = {false}
        onConfirm={() => { this.ok(); }}
        onCancel={() => { this.cancel(); }}
      >
        {content}
      </_SweetAlert>
    );
  }
}

 */

/* export class SweetAlert extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    }
    SweetAlert.current = this;
  }

  open({ title, content, onOk, okText, type }) {
    this.setState({
      title, content, onOk, open: true, okText, type
    });
  }

  ok() {
    let { onOk } = this.state;
    if (onOk) onOk();
    this.setState({ open: false });
  }

  getOKColor() {
    let { type } = this.state;
    if (type == "success") return "success";
    return "danger";
  }

  render() {
    let { title, content, open, okText, type } = this.state;
    let p = {};
    if (type) p[type] = true; else p.warning = true;
    return (
      <_SweetAlert show={open}
        {...p}
        showCancel
        confirmBtnText={okText || "确定"}
        confirmBtnBsStyle={this.getOKColor()}
        title={title || ''}
        showCancel={false}
        onConfirm={() => { this.ok(); }}
      >
        {content}
      </_SweetAlert>
    );
  }
} */

/* 
export class Snackbar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      vertical: null,
      horizontal: null,
    }
    Snackbar.current = this;
    this.list = [];
    this.timer = null;
  }

  open(p) {
    this.handleRequestClose();
    this._open(p);
  }

  _open(p) {
    p = Util.type(p) === "string" ? { message: p } : p;
    let { message, horizontal, vertical } = p;
    this.setState({
      message, horizontal, vertical, open: true
    });
    this.timer = setTimeout(() => {
      this.handleRequestClose();
    }, 3000);
  }

  handleRequestClose = () => {
    clearTimeout(this.timer);
    this.setState({ open: false });
  };

  render() {
    let { vertical, horizontal, message, open } = this.state;
    horizontal = horizontal || "center";
    vertical = vertical || "bottom";
    return (
      <_Snackbar
        onClick={() => { this.handleRequestClose(); }}
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        ContentProps={{
          'aria-describedby': 'snackbar-message-id',
        }}
        message={<span id="snackbar-message-id">{message}</span>}
      />
    );
  }
} */

function sweetConfirm(p) {
  Swal.fire({
    title: p.title,
    text: p.content,
    icon: p.type || 'warning',
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonColor: p.confirmButtonColor || '#f44336',
    cancelButtonColor: p.cancelButtonColor || '#9e9e9e',
    returnFocus: false,
    allowOutsideClick: false,
    confirmButtonText: p.okText || "确定",
    cancelButtonText: p.cancelText || "取消",
    customClass: {
      title: "mb-0 c-text-s3 c-font-weight-normal",
      content: "mb-0 c-text-s2 c-font-weight-normal"
    }
  }).then((result) => {
    if (result.isConfirmed) {
      if (p.onOk) p.onOk();
    }

    if (result.isDismissed) {
      if (p.onCancel) p.onCancel();
    }
  })
}

export const Message = {
  // confirm(title, content, onOk, onCancel) {
  //   if (type(content) === "function") {
  //     onCancel = onOk;
  //     onOk = content;
  //     content = null;
  //   }
  //   let c = Confirm.current;
  //   c.open(title, content, onOk, onCancel);
  // },
  // alert(title, content, onOk) {
  //   if (Util.type(content) == "function") {
  //     onOk = content;
  //     content = null;
  //   }
  //   var c = Alert.current;
  //   c.open(title, content, onOk);
  // },
  warning(title) {
    Message.sweetAlert({ title });
  },
  sweetConfirm,
  confirm: sweetConfirm,
  alert(p) {
    /*     var c = SweetAlert.current;
    c.open(p); */
  },
  snackbar(p) {
    /*     Snackbar.current.open(p); */
  }
};
